// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import date from '/util/date.js';
import {Tooltip} from '../../comp/tooltip';
import {TIME_FMT} from '../../utils/constants.js';
import './status_dot.less';

const OFFLINE_TIP = 'Device seems to be offline';
const fmt = d=>date.strftime(TIME_FMT, d);

export function Status_dot({meta, loading, className}){
    let tip = OFFLINE_TIP;
    let kind_class = 'easd_dot_offline';
    if (loading)
    {
        kind_class = 'easd_dot_loading';
        tip = '';
    }
    else if (meta?.[0])
    {
        const since = fmt(meta[0]);
        const uptime = date.dur_to_str(meta[1], {
            sep: ' ',
            units: 2,
            precision: 1000,
        });
        kind_class = 'easd_dot_online';
        tip = `Device online since ${since} UTC, ${uptime}`;
    }
    return <span className={cn('ea_status_dot', className)}>
      <Tooltip tip={tip} placement="top">
        <span className={cn('easd_dot', kind_class)}/>
      </Tooltip>
    </span>;
}
